const HomeActionTypes = {
  HOME_SYNC_START: "HOME_SYNC_START",
  HOME_SYNC_FINISH: "HOME_SYNC_FINISH",
  SET_EMPLOYEE_DATA: "SET_EMPLOYEE_DATA",

  THING_SYNC_START: "THING_SYNC_START",
  THING_SYNC_FINISH: "THING_SYNC_FINISH",
  RESET_THINGS: "RESET_THINGS",

  FAVORITE_SYNC_START: "FAVORITE_SYNC_START",
  FAVORITE_SYNC_FINISH: "FAVORITE_SYNC_FINISH",
  RESET_FAVORITES: "RESET_FAVORITES",

  UPDATE_HOME_SLIDE_ID: "UPDATE_HOME_SLIDE_ID",
  UPDATE_BANNER_FAVORITE: "UPDATE_BANNER_FAVORITE",
  UPDATE_BANNER_SHARE: "UPDATE_BANNER_SHARE",
  UPDATE_BANNER_COMMENT: "UPDATE_BANNER_COMMENT",

  UPDATE_SHOW_REGISTER_OVERLAY_FLAG: "UPDATE_SHOW_REGISTER_OVERLAY_FLAG",
  UPDATE_SHOW_SIGNIN_OVERLAY_FLAG: "UPDATE_SHOW_SIGNIN_OVERLAY_FLAG",
  UPDATE_SHOW_ACCOUNT_OVERLAY_FLAG: "UPDATE_SHOW_ACCOUNT_OVERLAY_FLAG",
  UPDATE_SHOW_RESET_PASSWORD_OVERLAY_FLAG:
    "UPDATE_SHOW_RESET_PASSWORD_OVERLAY_FLAG",
};

export default HomeActionTypes;
